import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadCurrentData } from "../store/actions";

import "./Poi.scss";
import { Card, Spinner } from "react-bootstrap";
import { AppContext } from "../context";

const Poi = ({ id, setAppState }) => {
  const dispatch = useDispatch();
  const [isImgLoad, setIsImgLoad] = useState(false);
  useEffect(() => {
    dispatch(loadCurrentData(id));
  }, [dispatch, id]);

  const { currentPoi } = useSelector(state => state.data);

  useEffect(() => {
    setTimeout(() => {
      setIsImgLoad(false);
    }, 50);
    setIsImgLoad(true);
  }, [currentPoi]);


  return (
    <AppContext.Consumer>
      {({ secondPage }) => (
        <div className="poi-page">
          <Card>
            <Card.Body>
              {currentPoi?.axono && (!isImgLoad ?
                <Card.Img id="infoPopupImg" variant="top" src={`./axonos/images/${currentPoi?.axono}.webp`} /> :
                <div className="spinner-load">
                  <Spinner animation="border" role="status" variant="danger">
                    <span className="visually-hidden" />
                  </Spinner>
                </div>)}
              <Card.Title className={"mt-3"}>{currentPoi.title}</Card.Title>
              {currentPoi?.surface && <Card.Text className={"mt-3"}>{currentPoi.surface} sq ft</Card.Text>}
              {currentPoi?.surface_sub && <Card.Text> {currentPoi.surface_sub}</Card.Text>}
              <Card.Text>{currentPoi?.description}</Card.Text>
            </Card.Body>
          </Card>
        </div>
      )}
    </AppContext.Consumer>
  );
};
export default Poi;
